(function ($) {

    $.fn.displaybutton = function () {

        $(this).bind('click', function (e) {
            var name = $(this).attr('name');
            name = name.replace(/([ #;?&,.+*~\':"!^$[\]()=>|\/@])/g, '\\$1');
            var $item = $('[data-displaybutton-parent=' + name + ']');
            $.each($item, function (index, item) {
                $(item).css('display', 'block');
            });

            $("button[type=submit]").attr("disabled", true);
            $(this).css('display', 'none');
        });
        return false;
    };

}(jQuery));
